import React from 'react'
import { connect } from 'react-redux'
import { Icon, NavBar } from 'antd-mobile'

import { History } from 'history'
import './base-header.less'
import { withRouter } from 'react-router'
import { divide } from 'mathjs'
interface Props {
  history?: History
  title: string
  left: React.ReactNode
  leftToHome: () => void
  right: React.ReactNode
  nav: React.ReactNode
  leftClick: () => void
}
const BaseHeader = ({
  history,
  title,
  left,
  leftToHome,
  right,
  nav,
  leftClick,
  className,
}: Props & any) => {
  return (
    nav || (
      <NavBar
        className={className}
        mode="light"
        leftContent={
          left || (
            <div className="nav-left">
              <div className="nav-btn-left" onClick={() => { leftClick ? leftClick() : history.goBack() }}>
                <Icon type="left" />
              </div>
              {leftToHome ? <div onClick={() => leftToHome()}>
                首页
              </div> : null}
            </div>
          )
        }
        rightContent={right}
      // onLeftClick={() => history.goBack()}
      >
        {title}
      </NavBar>
    )
  )
}

const mapStateToProps = (state: any) => {
  const { header } = state
  return {
    ...header,
  }
}

export default connect(mapStateToProps)(withRouter(BaseHeader))
